import { ref, computed, getCurrentInstance } from 'vue';
import { PageTabSpec, ComponentMetadata, ComponentUXSpec } from '../schemas';
import type { IComponentState } from './types';

export function useComponentState(props: any): IComponentState {
  const instance = getCurrentInstance();

  const isUserComponent = true;

  const $uid = ref<string>(instance?.type.name || 'AnonymousComponent');

  const $imodal = ref<any>(null);

  const routeTab = ref<PageTabSpec | null>(null);

  const loading = ref(false);

  const loaded = ref(false);

  const reloading = ref(false);

  const showLoadingIndicator = ref(false);

  const error = ref<any>(null);

  const lastLoaded = ref<number | null>(null);

  const canLoadData = ref(true);

  const pageDocument = ref<PageTabSpec>({ title: '' });

  const componentMetadata = ref<ComponentMetadata>({ kind: 'usercontrol' });

  const ux = ref<ComponentUXSpec>({});

  const isModalComponent = ref(false);

  const modalName = ref<string | undefined>(undefined);

  const friendlyName = computed(() => {
    return modalName.value || $uid.value;
  });

  return {
    isUserComponent,
    $uid,
    routeTab,
    loading,
    loaded,
    reloading,
    showLoadingIndicator,
    error,
    lastLoaded,
    canLoadData,
    pageDocument,
    componentMetadata,
    ux,
    isModalComponent,
    modalName,
    friendlyName,
  };
}
